module.exports = __webpack_public_path__ + "img/buithed_rareruggapes.3ef994e.png";